module.exports = __webpack_public_path__ + "img/mic-share-dark.b445d4e4.png";